import React from "react";
import StarIcon from "../../../assets/images/icons/start-icon.svg";

const DEFAULT_COPY = {
    link: {
        title: "Add Your Artist",
        description:
            "Link your artist profile to unlock performance metrics, financial insights, and link analytics.",
        button: "Link Your Artist",
    },
    subscribe: {
        title: "Unlock Artist Insights",
        description:
            "Subscribe to unlock performance metrics, financial insights, and link analytics.",
        button: "Subscribe to unlock",
    },
};

/**
 * Section-level unlock panel — matches Dashboard analytics overlay style.
 */
export default function ArtistManagerDspLockOverlay({
    needsLinkArtist = false,
    onLinkArtist,
    onSubscribe,
    title,
    description,
    buttonLabel,
    /** "center" | "top" — use top for tall scrollable sections */
    verticalAlign = "center",
    /** Smaller panel for row-level locks inside a card */
    compact = false,
    showButton = true,
    secondaryActionLabel,
    onSecondaryAction,
}) {
    const copy = needsLinkArtist ? DEFAULT_COPY.link : DEFAULT_COPY.subscribe;
    const handleClick = needsLinkArtist ? onLinkArtist : onSubscribe;
    const alignClass =
        verticalAlign === "top"
            ? "items-start pt-8 md:pt-12"
            : "items-center";

    return (
        <div
            className={`absolute inset-0 z-20 flex justify-center rounded-xl bg-black/45 px-2 ${alignClass}`}
        >
            <div
                className={`w-full rounded-xl bg-white text-center shadow-lg ${
                    compact ? "max-w-xs p-3" : "max-w-md p-5"
                }`}
            >
                <h3
                    className={`font-bold text-theme_clr1 ${
                        compact ? "mb-1 text-sm" : "mb-2 text-lg"
                    }`}
                >
                    {title || copy.title}
                </h3>
                {!compact && (
                    <p className={`${showButton ? "mb-4" : "mb-0"} text-sm text-slate-600`}>
                        {description || copy.description}
                    </p>
                )}
                {showButton ? (
                    <div className={compact ? "" : "flex flex-col items-center"}>
                        <button
                            type="button"
                            className={`btn-custom3 inline-flex items-center justify-center gap-2 ${
                                compact ? "!px-3 !py-1.5 text-xs" : "!px-5 !py-2"
                            }`}
                            onClick={handleClick}
                        >
                            {buttonLabel || copy.button}
                            {!needsLinkArtist && (
                                <img
                                    src={StarIcon}
                                    alt=""
                                    className="h-[16px] w-[16px] min-w-[16px]"
                                />
                            )}
                        </button>
                        {secondaryActionLabel && onSecondaryAction ? (
                            <button
                                type="button"
                                className={`font-medium text-theme_clr1 underline underline-offset-2 hover:text-theme_clr2 ${
                                    compact ? "mt-2 text-xs" : "mt-3 text-sm"
                                }`}
                                onClick={onSecondaryAction}
                            >
                                {secondaryActionLabel}
                            </button>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
}
